import { Navigate, useParams } from "react-router-dom";
import { Steps } from "antd";
import { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import UserPrivateComponent from "../../PrivateRoutes/UserPrivateComponent";
import ConfirmModal from "../../ConfirmationModal/ConfirmModal";
import FranchiseForm from "../FranchiseForm";
import AssignSlot from "../../slot/AssignSlot";
import ApplyDiscount from "../../discount/ApplyDiscount";
const CreateFranchise = (props) => {
  const { id } = useParams()
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [selectedGames, setSelectedGames] = useState([]);
  const [maxPlayers, setMaxPlayers] = useState(0)
  const [isSlotsCreated, setIsSlotsCreated] = useState(false);
  const [formSaving, setFormSaving] = useState(false);
  const [isFormChanged, setIsFormChanged] = useState({
    submitFunction: null,
    state: false
  })
  const [error, setError] = useState(null)
  const [current, setCurrent] = useState(0);
  const [userId, setUserId] = useState("")
  const [stepperProgress, setStepperProgress] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [tabKeyToChange, setTabKeyToChange] = useState(null)
  const [franchiseSettings, setFranchiseSettings] = useState({})
  const { Step } = Steps;

  useEffect(() => {
    if (stepperProgress < current) {
      setStepperProgress(current)
    }
  }, [current])


  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }


  const handleTabChange = (key) => {
    if (userId && selectedGames.length > 0) {
      if (error) {
        toast.error(error)
        return;
      }
      if (isFormChanged.state && isFormChanged.submitFunction) {
        setTabKeyToChange(key)
        setIsModalOpen(true)
      } else {
        setCurrent(key);
      }
    }
    else {
      if (stepperProgress >= key) {
        setCurrent(key)
      }
    }
  }

  const handleOk = async () => {
    try {
      setFormSaving(true)
      await isFormChanged.submitFunction(() => {
        setCurrent(tabKeyToChange);
      })
      setCurrent(tabKeyToChange);
      setIsFormChanged({
        submitFunction: null,
        state: false
      })
    } catch (error) {
      console.error(error)
    }
    finally {
      setFormSaving(false)
      setIsModalOpen(false)
    }

  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setCurrent(tabKeyToChange);
    setIsFormChanged({
      submitFunction: null,
      state: false
    })
  }

  return (

    <div className="px-4">
      <Fragment>
        <Steps current={current} className="w-full flex justify-between stepper-wrapper border-radius-top">
          <Step onClick={() => handleTabChange(0)} title="Franchise Information" description="Enter your Franchise Information." />
          <Step onClick={() => handleTabChange(1)} title="Assign Games" description="Assign Games." />
          <Step onClick={() => handleTabChange(2)} title="Assign Slots" description="Assign Slots details." />
          <Step onClick={() => handleTabChange(3)} title="Apply Discount" description="Apply Discount details." />
        </Steps>
        <UserPrivateComponent permission={"create-user"}>
          <FranchiseForm setError={setError} error={error} setFranchiseSettings={setFranchiseSettings} setIsFormChanged={setIsFormChanged} current={current} setCurrent={setCurrent} userId={userId} setUserId={setUserId} setSelectedGames={setSelectedGames} selectedGames={selectedGames} setMaxPlayers={setMaxPlayers} />
          {current === 2 && (
            <AssignSlot isSlotsCreated={isSlotsCreated} setIsSlotsCreated={setIsSlotsCreated} userId={userId} setUserId={setUserId} franchiseSettings={franchiseSettings} setIsFormChanged={setIsFormChanged} selectedGames={selectedGames} setSelectedGames={setSelectedGames} setCurrent={setCurrent} />
          )}
          {current === 3 && (
            <ApplyDiscount setIsFormChanged={setIsFormChanged} userId={userId} maxPlayers={maxPlayers} />
          )}
        </UserPrivateComponent>
        <ConfirmModal loading={formSaving} message="You want to save the changes?" open={isModalOpen} handleCloseModal={() => setIsModalOpen(false)} handleOk={handleOk} handleCancel={handleCancel} />
      </Fragment>
    </div>
  )
};

export default CreateFranchise;
